// extracted by mini-css-extract-plugin
module.exports = {"container":"AdvantagesItem_container__3lvOu","img":"AdvantagesItem_img__26QcP","title":"AdvantagesItem_title__2CSRF","text":"AdvantagesItem_text__vNbCW"};